import { AxiosInstance, AxiosResponse } from "axios";
import { startNativeDownload } from "./BaseApi";

export abstract class PDADataService{
    protected abstract prefixUrl: string;
    protected api: AxiosInstance;
    constructor(api: AxiosInstance) {
      this.api = api;
    }

    // Получить файл как Blob, не сохраняя его на диск — для просмотра в браузере
    // (PDF/Word-вьювер), в отличие от downloadFile, который дёргает <a download>.
    protected async fetchBlob(url: string): Promise<Blob> {
      const response = await this.api.get(url, { responseType: `blob` });
      return new Blob([response.data]);
    }

    protected async downloadFile(url: string, _fallbackFileName?: string) {
      await startNativeDownload(url);
      return { data: new Blob() } as AxiosResponse<Blob>;
    }
}